<template>
  <div class="live">
    <iframe width="100%" height="100%" src="http://e.cippe.com.cn/live/index_en" frameborder="0"></iframe>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
  .live{
    width: 100%;
    height: calc(100vh - 261px);
    overflow: hidden;
  }

</style>